
var state = {
	show:false,
	tabledata:[],//列表
	page:1,//部门资源列表页数
	pagesize:20,//部门资源列表条数
	total:0,//总数
	pid:0,//默认层级
	pathlength:0,   //文件路径长度
	path:[],		//文件路径
	loading:false,
}
export default state



// WEBPACK FOOTER //
// ./src/store/modules/personal/state.js